<template>
<div>
  <entry-containers-sidebar :containerTypes="containerTypes" :container="container" :entryId="entryId" @containerUpdated="containerUpdated"/>
  <vs-table :data="data" maxHeight="60vh">
    <template slot="thead">
      <vs-th> {{ $t('id').toUpperCase() +' '+ $tc('container') | capitalize }} </vs-th>
      <vs-th> {{ $t('label') | capitalize }} </vs-th>
      <vs-th> {{ $tc('type') | capitalize }} </vs-th>
      <vs-th> {{ $t('quantity') | capitalize }} </vs-th>
      <vs-th> {{ $t('located_at') | capitalize }} </vs-th>
      <vs-th> {{ $t('comments') | capitalize }} </vs-th>
      <vs-th v-if="hasPermission(['IU ENTRY EDIT'])"> {{ $t('actions') | capitalize }} </vs-th>
    </template>
    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].id }}
        </vs-td>
        <vs-td>
          {{ data[i].label }}
        </vs-td>
        <vs-td>
          {{ data[i].type_name }}
        </vs-td>
        <vs-td>
          {{ data[i].quantity }}
        </vs-td>
        <vs-td>
          {{ data[i].location_name }}
        </vs-td>
        <vs-td>
          {{ data[i].comment }}
        </vs-td>
        <vs-td v-if="hasPermission(['IU ENTRY EDIT'])">
          <vx-tooltip
            :text="$t('edit')"
            style="display: inline-flex"
          >
            <feather-icon
              @click="updateContainer(data[i])"
              icon="EditIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
            />
          </vx-tooltip>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</div>
  
  
</template>

<script>
import EntryContainersSidebar from './EntryContainersSidebar.vue'
import entry from '@/http/requests/entry'
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    entryId: {
      type: String,
      required:true
    }
  },
  components:{
    EntryContainersSidebar
  },
  data(){
    return {
      container:{},
      containerTypes:[]
    }
  },
  methods: {
    init(){
      this.getContainerTypes()
    },
    getContainerTypes(){
      entry.getContainerTypes().then(res => {
        this.containerTypes=res.data.data
      }).catch( err => {
        console.log(err)
      })
    },
    updateContainer(data) {
      this.container = data
      this.$store.dispatch('toggleSidebar', 'entry-container')
    },
    containerUpdated(){
      this.$emit('containerUpdated')
    }
  },
  mounted() {
    this.init()
  },
}
</script>

<style>
</style>